import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {AppComponent} from '../../../app.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  constructor(private auth: AuthService, private app: AppComponent) { }

  ngOnInit() {
    this.app.setTitle('Profile');
  }

  logout() {
    this.auth.logout();
  }
}
